/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Index&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Index&lang=js"

import "./index.vue?vue&type=style&index=0&id=c16fe0e0&scoped=true&lang=scss"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c16fe0e0"]])

export default __exports__